import React, { useContext, useState, useEffect } from "react";
import Header from "../Common/Header";
import Sidebar from "../Common/Sidebar";
import Footer from "../Common/Footer";
import { GMCContext } from "../../GMCContext";
import Copy from "../Common/Copy";
import axios from "axios";
import Pagination from "../Common/Pagination";


export default function UserlistbyDate() {
  const { setIsSidebarEnabled, formatDateTime } = useContext(GMCContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");


  const getData = async () => {
    if (!fromDate || !toDate) {
      alert("Please select both From and To dates!");
      return;
    }


    // ✅ Ensure proper YYYY-MM-DD formatting
    const formatToYMD = (dateString) => {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const formattedFrom = formatToYMD(fromDate);
    const formattedTo = formatToYMD(toDate);

    try {
      setLoading(true);
      const res = await axios.get(
        `https://futureadmin.gtbspeer.com/api/referred-users/list?telegram_id=1169158525&fromdate=${formattedFrom}&to_date=${formattedTo}`
      );

      const list = res.data?.data || [];
      // console.log('list', list);

      setData(list);
      setPages(Math.ceil(list.length / pageSize));
    } catch (err) {
      console.error("Error Fetching Data:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Sidebar />
      <div id="layout-wrapper">
        <div
          className="vertical-overlay"
          onClick={() => setIsSidebarEnabled((prev) => !prev)}
        />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* 🧭 Page Title */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center bg-galaxy-transparent justify-content-between">

                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item"><a href="javascript: void(0);">Tables</a></li>
                      <li className="breadcrumb-item active">User List By Date</li>
                    </ol>
                  </div>
                </div>
              </div>

              {/* 🗓️ Date Filter Controls */}
              <div className="card p-3 shadow-sm mb-4">
                <div className="row g-3 align-items-end">
                  <div className="col-md-4 col-12">
                    <label className="form-label fw-semibold">From Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 col-12">
                    <label className="form-label fw-semibold">To Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 col-12 d-flex align-items-end">
                    <button
                      className="btn btn-primary w-100"
                      onClick={getData}
                      disabled={loading}
                    >
                      {loading ? "Fetching..." : "Fetch Data"}
                    </button>
                  </div>
                </div>
              </div>

              {/* 🧾 Table Section */}
              <div className="card position-relative">
                <div className="table-responsive table-card mt-3 mb-1 position-relative">
                  {/* 🔄 Overlay Loader */}
                  {loading && (
                    <div
                      className="d-flex flex-column justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100"
                      style={{
                        background: "rgba(255,255,255,0.8)",
                        zIndex: 10,
                        backdropFilter: "blur(3px)",
                      }}
                    >

                      <br />
                      <div class="d-flex justify-content-around my-4">
                        <div class="spinner-border text-primary" role="status"></div>

                      </div>
                      <h6 className="text-primary fw-semibold mt-3">
                        Please wait...
                      </h6>

                      <style>
                        {`@keyframes spin { 
                            0% { transform: rotate(0deg); } 
                            100% { transform: rotate(360deg); } 
                        }`}
                      </style>
                    </div>
                  )}

                  <table
                    className="table align-middle table-nowrap" id="customerTable"
                    style={{
                      opacity: loading ? 0.5 : 1,
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <thead className="table-light">
                      <tr>
                        <th className="gridjs-th text-center">#</th>
                        <th className="gridjs-th text-center">Telegram ID</th>
                        <th className="gridjs-th text-center">Username</th>
                        <th className="gridjs-th text-center">Joining Date</th>
                      </tr>
                    </thead>

                    <tbody>
                      {!loading && data.length === 0 ? (
                        <tr>
                          <td
                            colSpan="4"
                            className="gridjs-td text-center py-4 text-muted fs-5"
                          >
                            No data found
                          </td>
                        </tr>
                      ) : (
                        data
                          .slice(
                            (currentPage - 1) * pageSize,
                            currentPage * pageSize
                          )
                          .map((ele, i) => (
                            <tr key={i}>
                              <td className="gridjs-td text-center">
                                {(currentPage - 1) * pageSize + (i + 1)}
                              </td>
                              <td className="gridjs-td text-center">
                                {ele.Telegram_Id || "-"}
                                <Copy data={ele.Telegram_Id} />
                              </td>
                              <td className="gridjs-td text-center">
                                <div>
                                  <a
                                    href={`${process.env.REACT_APP_EXPLORER}/address/${ele.Full_Name}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-primary"
                                  >
                                    {ele.Full_Name}
                                  </a>
                                  <Copy data={ele.Full_Name} />
                                </div>
                              </td>
                              <td className="gridjs-td text-center">{formatDateTime(ele.Joined_At)}</td>
                            </tr>
                          ))
                      )}
                    </tbody>
                  </table>
                </div>

                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  pages={pages}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
